import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { getCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type { MerchandiserView } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import { getColumnWidth } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/MerchandiserCommon';

export const getMerchandiserCard = (
  section: MerchandiserView,
  height: number
): GridCard<PlaneTypes.Layout_Merchandiser> => {
  const width = getColumnWidth();
  const card = getCard<PlaneTypes.Layout_Merchandiser>({
    data: { ...section, sectionId: section.dtoData.id },
    type: PlaneTypes.Layout_Merchandiser,
    size: { width, height },
    blockHover: true,
    backgroundColor: section.type === 'Merchandiser5' ? 'red' : 'green',
  });

  card.key = card.data?.key;

  return card;
};
